<template>
  <div>
    <!-- Header + breadcrumb -->
    <div style="background: linear-gradient(45deg, #28a745, #20c997); padding: 20px 0;">
      <layouts-header />
      <breadcrumb :title="blog?.title" text="الصفحات" text1="الاخبار" />
    </div>

    <!-- Article Section -->
    <div class="blog-section" v-if="blog">
      <div class="container">
        <!-- عنوان رئيسي -->
        <h1 class="gradient-title mb-4 text-center">{{ blog.title }}</h1>

        <!-- صورة المقال -->
        <div class="bloginner-img mb-4 text-center">
          <img :src="blog.image" class="img-fluid rounded" :alt="blog.title" />
        </div>

        <!-- وصف + تاريخ -->
        <p class="text-muted mb-2">
          <i class="fa-solid fa-calendar-days"></i> {{ blog.created_at }}
        </p>
        <div class="blog-description">
          <p>{{ blog.description }}</p>
        </div>

        <!-- static blockquote -->
        <blockquote class="blog-quotes">
          <img src="@/assets/img/blogquote.svg" alt="اقتباس" />
          <p>إذا كنت تبحث عن سيارة جديدة، فالمكان المناسب يمكن أن يصنع فرقًا كبيرًا في السعر وجودة الخدمة.</p>
          <h6>محمود الجوهري</h6>
        </blockquote>

        <!-- static extra description -->
        <div class="blog-description">
          <p>سواء كنت تفضل السيارات الاقتصادية أو السيارات الفاخرة، فستجد دائمًا خيارات متعددة تناسب احتياجاتك.</p>
        </div>

        <!-- مشاركة + تاقز -->
        <div class="share-postsection">
          <div class="row">
            <div class="col-lg-4">
              <div class="sharelink d-flex align-items-center">
                <a href="javascript:void(0);" class="share-img"><i class="feather-share-2"></i></a>
                <a href="javascript:void(0);" class="share-text">مشاركة</a>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="tag-list">
                <ul class="tags">
                  <li>سيارات</li>
                  <li>المعرض</li>
                  <li>السرعة</li>
                  <li>الماركة</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- السابق و التالي -->
        <div class="blogdetails-pagination">
          <ul>
            <li v-if="prevBlog">
              <router-link :to="`/blog/blog-details/${prevBlog.id}`" class="prev-link">
                <i class="fas fa-regular fa-arrow-left"></i> المقال السابق
              </router-link>
              <router-link :to="`/blog/blog-details/${prevBlog.id}`">
                <h3>{{ prevBlog.title }}</h3>
              </router-link>
            </li>
            <li v-if="nextBlog">
              <router-link :to="`/blog/blog-details/${nextBlog.id}`" class="next-link">
                المقال التالي <i class="fas fa-regular fa-arrow-right"></i>
              </router-link>
              <router-link :to="`/blog/blog-details/${nextBlog.id}`">
                <h3>{{ nextBlog.title }}</h3>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- تقييمات ثابتة -->
        <div class="review-sec mb-0">
          <div class="review-header">
            <h4>التقييمات <span>(2)</span></h4>
            <div class="reviewbox-list-rating">
              <p>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled"></i>
                <span> (5 من 5)</span>
              </p>
            </div>
          </div>

          <!-- review 1 -->
          <div class="review-card">
            <div class="review-header-group">
              <div class="review-widget-header">
                <span class="review-widget-img">
                  <img src="@/assets/img/profiles/avatar-01.jpg" class="img-fluid" alt="مستخدم" />
                </span>
                <div class="review-design">
                  <h6>خالد</h6>
                  <p>02 يناير 2023</p>
                </div>
              </div>
            </div>
            <p>المعرض كان ممتاز من حيث الأسعار والخدمة، أنصح به بشدة لأي شخص يريد شراء سيارة.</p>
          </div>

          <!-- review 2 -->
          <div class="review-card">
            <div class="review-header-group">
              <div class="review-widget-header">
                <span class="review-widget-img">
                  <img src="@/assets/img/profiles/avatar-02.jpg" class="img-fluid" alt="مستخدم" />
                </span>
                <div class="review-design">
                  <h6>سارة</h6>
                  <p>02 يناير 2023</p>
                </div>
              </div>
            </div>
            <p>فريق العمل متعاون جدًا وساعدني في اختيار السيارة المناسبة لعائلتي، تجربة رائعة.</p>
          </div>
        </div>

        <!-- أضف تعليقك -->
        <div class="review-sec mb-0">
          <div class="review-header">
            <h4>أضف تعليقك</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="sendFeedback">
              <div class="input-block mb-3">
                <label>الاسم الكامل <span class="text-danger">*</span></label>
                <input type="text" class="form-control" required />
              </div>
              <div class="input-block mb-3">
                <label>البريد الإلكتروني <span class="text-danger">*</span></label>
                <input type="email" class="form-control" required />
              </div>
              <div class="input-block mb-3">
                <label>التعليق</label>
                <textarea rows="4" class="form-control" v-model="message"></textarea>
              </div>
              <button class="btn btn-primary submit-review">إرسال التقييم</button>
              <p v-if="sent" class="text-success mt-2">✅ تم إرسال تعليقك بنجاح</p>
            </form>
          </div>
        </div>
      </div>
    </div>

    <layout-footer />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useBlogStore } from "@/stores/blog-store";

const blogStore = useBlogStore();
const route = useRoute();
const id = Number(route.params.id);

const blog = computed(() => blogStore.blogs.find((b) => b.id === id));
const currentIndex = computed(() => blogStore.blogs.findIndex((b) => b.id === id));

const prevBlog = computed(() =>
  currentIndex.value > 0 ? blogStore.blogs[currentIndex.value - 1] : null
);
const nextBlog = computed(() =>
  currentIndex.value < blogStore.blogs.length - 1 ? blogStore.blogs[currentIndex.value + 1] : null
);

const message = ref("");
const sent = ref(false);

function sendFeedback() {
  sent.value = true;
  message.value = "";
}

onMounted(async () => {
  if (!blogStore.blogs.length) {
    await blogStore.fetchBlogs();
  }
});
</script>

<style scoped>
.gradient-title {
  background: linear-gradient(to right, #0e3b2f, #2fa66b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
</style>
